<div class="app-container">
  @if (loggedIn$ | async) {
  <app-header></app-header>
  }
  <div class="main-wrapper">
    @if ((loggedIn$ | async) && (hasPermissions$ | async)) {
      <app-side-nav></app-side-nav>
    }
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
